'use client';

import { cn } from '@bazaar-marketplace/utils';
import Image from 'next/image';
import Link from 'next/link';
import { VerifiedText } from '~/components/typography/verified-text';

interface BrandCardProps {
  id?: string;
  variant: 'carousel' | 'grid';
  name: string;
  image?: string | null;
  imagePosition?: 'contain' | 'cover';
  textWidthClassName?: string;
  customImageHeightClassName?: string;
  noSquare?: boolean;
  hideVerifiedBadge?: boolean;
  onClick?: () => void;
}

export const BrandCard = ({
  id,
  image,
  imagePosition = 'cover',
  name,
  variant,
  customImageHeightClassName,
  noSquare,
  hideVerifiedBadge,
  onClick,
}: BrandCardProps) => (
  <Link
    className={cn(
      'rounded-3xl bg-white/10 border-[1px] border-[#FFFFFF1A] p-2 pb-4 flex flex-col gap-3 hover:bg-white/15 transition-colors',
      noSquare ? '' : 'aspect-square',
      variant === 'carousel' ? 'w-1/2' : 'w-full',
    )}
    href={onClick ? '#' : `/collections/${id}`}
    onClick={(event) => {
      if (onClick) {
        event.preventDefault();
        onClick();
      }
    }}
  >
    {image ? (
      <Image
        alt={name}
        className={cn(
          'w-full rounded-2xl',
          customImageHeightClassName ?? 'h-[141px]',
          imagePosition === 'cover' ? 'object-cover' : 'object-contain',
        )}
        height={100}
        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
        src={image}
        width={100}
      />
    ) : null}
    <div className={variant === 'carousel' ? 'inline-flex items-center' : 'grid overflow-hidden'}>
      <h3
        className={cn(
          'text-white text-sm font-bold font-quicksand px-2',
          variant === 'carousel' ? 'w-[157px]' : 'w-full overflow-hidden',
        )}
      >
        <VerifiedText hideBadge={hideVerifiedBadge} singleLine text={name} />
      </h3>
    </div>
  </Link>
);
